import env from '@config/env.config';

/**
 * Keycloak integration config.
 *
 * The browser never talks to Keycloak directly. All password-grant, admin
 * (registration), TOTP and brokered social (Google / passkey) operations are
 * proxied through a same-origin Backend-for-Frontend (BFF) mounted at
 * `authBasePath`. The BFF holds the confidential client secret and admin
 * credentials, sets HttpOnly refresh cookies, and forwards to Keycloak.
 *
 * When `enabled` is false (default in preview), the auth layer uses an
 * in-memory mock so the app is fully functional without a Keycloak server.
 */
export const keycloakConfig = {
  enabled: env.keycloak.enabled,
  basePath: env.keycloak.authBasePath,
  realm: env.keycloak.realm,
  clientId: env.keycloak.clientId,
} as const;

/** Server-mediated auth endpoints (relative to same origin). */
export const authEndpoints = {
  login: `${keycloakConfig.basePath}/login`,
  register: `${keycloakConfig.basePath}/register`,
  logout: `${keycloakConfig.basePath}/logout`,
  session: `${keycloakConfig.basePath}/session`,
  forgotPassword: `${keycloakConfig.basePath}/forgot-password`,
  otpVerify: `${keycloakConfig.basePath}/otp/verify`,
  otpEnrollStart: `${keycloakConfig.basePath}/otp/enroll/start`,
  otpEnrollConfirm: `${keycloakConfig.basePath}/otp/enroll/confirm`,
  // Brokered identity providers → Keycloak handles the redirect dance server-side.
  social: (provider: 'google' | 'passkey') =>
    `${keycloakConfig.basePath}/social/${provider}`,
} as const;
